import React, { useState, useEffect } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import {
  Box,
  Typography,
  Button,
  TextField,
  Grid,
  CircularProgress,
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import { customTextColor } from "../../utils/const";
import { useDispatch, useSelector } from "react-redux";
import { getCandidate } from "../../redux/hotlist/hotListSlice";
import { allSkill } from "../../redux/common/skillSlice";
const JobSendDrawer = ({ show, handleClose, candidate }) => {
  const dispatch = useDispatch();
  const [jobForm, setJobForm] = useState({
    jobTitle: "",
    jobLocation: "",
    endClient: "",
    rate: "",
    jobDescription: "",
  });

  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location) || [];
  const candidateDetails = useSelector((state) => state.hotlist);
  const skillData = useSelector((state) => state.skill.data);
  const { candidateDetail } = candidateDetails;
  const { loading } = candidateDetails;

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };

  const getSkillNamesByIds = (skillIds) => {
    return (
      skillData?.locations
        ?.filter((skill) => skillIds?.includes(skill.id))
        .map((skill) => skill.name)
        .join(", ") || ""
    );
  };

  useEffect(() => {
    if (candidate?.id) {
      dispatch(getCandidate(candidate?.id));
      dispatch(allSkill());
    }
  }, [dispatch, candidate?.id]);

  const handleJobFormChange = (e) => {
    const { name, value } = e.target;
    setJobForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSendJob = () => {
    if (
      !jobForm.jobTitle ||
      !jobForm.jobLocation ||
      !jobForm.rate ||
      !jobForm.jobDescription
    ) {
      alert("All fields except End Client are mandatory!");
      return;
    }
    handleClose();
  };

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={true}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "65px",
        width: "50%",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
      }}
    >
      <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
        <Box sx={{ padding: "10px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0px 10px",
              mb: "10px",
            }}
          >
            <Typography variant="h6" style={{ color: customTextColor }}>
              {candidate?.name}, {candidate?.role}, {candidate?.location}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <RxCross2
                style={{
                  fontSize: "15px",
                  cursor: "pointer",
                  color: customTextColor,
                }}
                onClick={handleClose}
              />
            </Box>
          </Box>

          <Box
            sx={{
              padding: "0px 10px",
              display: "flex",
              flexDirection: "column",
              height: "70vh",
            }}
          >
            {loading?.getCandidate === "pending" && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 2,
                  py: 5,
                }}
              >
                <CircularProgress />
              </Box>
            )}
            {loading?.getCandidate !== "pending" && (
              <>
                <Grid container sx={{ padding: "10px" }}>
                  <Grid item xs={6}>
                    <ul
                      style={{
                        listStyleType: "square",
                        paddingLeft: "20px",
                        margin: 0,
                      }}
                    >
                      <li>
                        <Typography style={{ fontSize: "14px" }}>
                          {candidateDetail?.full_name || candidate?.name}
                        </Typography>
                      </li>
                      <li>
                        <Typography style={{ fontSize: "14px" }}>
                          {candidateDetail?.total_experience < 1
                            ? `${Math.round(
                                candidateDetail?.total_experience * 12
                              )} Months`
                            : `${candidateDetail?.total_experience} ${
                                candidateDetail?.total_experience === 1
                                  ? "Year"
                                  : "Years"
                              }` || candidate?.experience}
                        </Typography>
                      </li>
                      <li>
                        <Typography style={{ fontSize: "14px" }}>
                          {candidateDetail?.email || candidate?.email}
                        </Typography>
                      </li>
                      <li>
                        <Typography style={{ fontSize: "14px" }}>
                          {candidateDetail?.willing_to_relocate
                            ? "Willing to Relocate"
                            : "Not Willing to Relocate" ||
                              candidate?.availability}
                        </Typography>
                      </li>
                      <li>
                        <Typography style={{ fontSize: "14px" }}>
                          ${candidateDetail?.rate} Hourly || {candidate?.rate}
                        </Typography>
                      </li>
                    </ul>
                  </Grid>

                  <Grid item xs={6}>
                    <ul
                      style={{
                        listStyleType: "square",
                        paddingLeft: "20px",
                        margin: 0,
                      }}
                    >
                      <li>
                        <Typography style={{ fontSize: "14px" }}>
                          {candidateDetail?.current_job_title ||
                            candidate?.role}
                        </Typography>
                      </li>
                      <li>
                        <Typography style={{ fontSize: "14px" }}>
                          {candidateDetail?.mobile_no || candidate?.phone}
                        </Typography>
                      </li>
                      <li>
                        <Typography style={{ fontSize: "14px" }}>
                          {(candidateDetail?.current_location &&
                            getLocationById(
                              candidateDetail?.current_location
                            )) ||
                            candidate?.location}
                        </Typography>
                      </li>
                      <li>
                        <Typography style={{ fontSize: "14px" }}>
                          {candidateDetail?.p_tax_team ||
                            candidate?.contract ||
                            "Contract"}
                        </Typography>
                      </li>
                      <li>
                        <Typography style={{ fontSize: "14px" }}>
                          {(candidateDetail?.work_authorization &&
                            getWorkAuthorization(
                              candidateDetail?.work_authorization
                            )) ||
                            candidate?.visa}
                        </Typography>
                      </li>
                      <li>
                        <Typography style={{ fontSize: "14px" }}>
                          {getPreferLocationNames(
                            candidateDetail?.prefer_location
                          )}
                        </Typography>
                      </li>
                    </ul>
                  </Grid>
                </Grid>

                <Box sx={{ padding: "10px" }}>
                  <Typography
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      marginBottom: "5px",
                      textTransform: "uppercase",
                    }}
                  >
                    Primary Skills
                  </Typography>
                  <Typography style={{ fontSize: "14px" }}>
                    {getSkillNamesByIds(candidateDetail?.primary_skills)}
                  </Typography>
                </Box>

                <Box sx={{ padding: "10px" }}>
                  <Typography
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      marginBottom: "5px",
                      textTransform: "uppercase",
                    }}
                  >
                    Secondary Skills
                  </Typography>
                  <Typography style={{ fontSize: "14px" }}>
                    {getSkillNamesByIds(candidateDetail?.secondary_skills)}
                  </Typography>
                </Box>
              </>
            )}

            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
              Fill in the below details
            </Typography>
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                label="Job Title"
                name="jobTitle"
                value={jobForm.jobTitle}
                onChange={handleJobFormChange}
                variant="outlined"
                required
                sx={{ flex: 1 }}
              />
              <TextField
                label="Job Location"
                name="jobLocation"
                value={jobForm.jobLocation}
                onChange={handleJobFormChange}
                variant="outlined"
                required
                sx={{ flex: 1 }}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                label="End Client (Optional)"
                name="endClient"
                value={jobForm.endClient}
                onChange={handleJobFormChange}
                variant="outlined"
                sx={{ flex: 1 }}
              />
              <TextField
                label="Rate"
                name="rate"
                value={jobForm.rate}
                onChange={handleJobFormChange}
                variant="outlined"
                required
                sx={{ flex: 1 }}
              />
            </Box>

            <TextField
              fullWidth
              name="jobDescription"
              value={jobForm.jobDescription}
              onChange={handleJobFormChange}
              multiline
              rows={4}
              variant="outlined"
              required
              placeholder="Add your job description here..."
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "4px",
                },
              }}
            />
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                variant="contained"
                onClick={handleSendJob}
                sx={{
                  backgroundColor: "#00b0f0",
                  textTransform: "capitalize",
                  borderRadius: "3px",
                  padding: "5px 20px",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#0085b4",
                    boxShadow: "none",
                  },
                }}
              >
                Send Job
              </Button>
              <Button
                variant="outlined"
                onClick={handleClose}
                sx={{
                  borderColor: "#00b0f0",
                  color: "#00b0f0",
                  textTransform: "capitalize",
                  borderRadius: "3px",
                  padding: "5px 20px",
                  "&:hover": {
                    borderColor: "#0085b4",
                    color: "#0085b4",
                  },
                }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default JobSendDrawer;
